import { render, staticRenderFns } from "./CampaignHistory.vue?vue&type=template&id=3f2433c4&scoped=true&"
import script from "./CampaignHistory.vue?vue&type=script&lang=js&"
export * from "./CampaignHistory.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHistory.vue?vue&type=style&index=0&id=3f2433c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2433c4",
  null
  
)

export default component.exports